export function EventCardWidget({ event, configuration }) {
  let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  let timeOptions = { hour: '2-digit', minute: '2-digit' };


  function truncateWords(text, maxWords) {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > maxWords
      ? words.slice(0, maxWords).join(" ") + "..."
      : text;
  }

  return (
    <div className="card p-4 shadow-sm card-border-left min-height-16em">
      <div className="d-flex flex-column align-items-start gap-1">
        <div className="d-flex align-items-center gap-2">
          <i className="fa-solid fa-calendar text-primary"></i>
          <span className="text-secondary fs-7">
            {new Date(event.start_date).toLocaleDateString(undefined, dateOptions)}
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <i className="fa-solid fa-clock text-primary"></i>
          <span className="text-secondary fs-7">
            {new Date(event.start_date).toLocaleTimeString(undefined, timeOptions)} - 
            {new Date(event.end_date).toLocaleTimeString(undefined, timeOptions)}
          </span>
        </div>
      </div>
      
      <h5 className="h5 mt-2">{truncateWords(event?.title, 10)}</h5>
      
      <div className="d-flex align-items-center justify-content-end mt-auto w-100">
        <a href={event.url} className="btn btn-primary">
          {configuration.translations.moreInfo}
        </a>
      </div>
    </div>
  );
}
